import React, { useEffect, useState } from "react";
import Navbar from "src/Component/Navbar";
import BackRouteContainer from "src/Component/grid-component/BackButtonComponent";
import logo from "../../asset/backimmigration.png";
import ImmersionBanner from "./ImmersionBanner";
import { useParams } from "react-router";
import {
  EuropeImmersionBanner,
  MiddleEastImmersionBanner,
  NorthAmericaImmersionBanner,
  SouthEastAsiaImmersionBanner,
} from "../../../src/Component/immersion/immersioncountryjson/ImmerisonBannerData";
import ImmerisonCountryBenefit from "./ImmerisonCountryBenefit";
import {
  EuropeImmersionBenefit,
  MiddleEastImmersionBenefit,
  NorthAmericaImmersionBenefit,
  SouthEastAsiaImmersionBenefit,
} from "./immersioncountryjson/ImmersionCountryBenefitData";
import {
  EuropeImmersionObjectives,
  MiddleEastImmersionObjectives,
  NorthAmericaImmersionObjectives,
  SouthEastAsiaImmersionObjectives,
} from "./immersioncountryjson/ImmerisonCountryObjectivesData";
import {
  EuropeImmersionOverview,
  MiddleEastImmersionOverview,
  NorthAmericaImmersionOverview,
  SouthEastAsiaImmersionOverview,
} from "./immersioncountryjson/ImmerisonProgramOverviewData";

const jsonData = [
  {
    path: "middle-east",
    banner: MiddleEastImmersionBanner,
    benefit: MiddleEastImmersionBenefit,
    objectives: MiddleEastImmersionObjectives,
    overview: MiddleEastImmersionOverview,
  },
  {
    path: "southeast-asia",
    banner: SouthEastAsiaImmersionBanner,
    benefit: SouthEastAsiaImmersionBenefit,
    objectives: SouthEastAsiaImmersionObjectives,
    overview: SouthEastAsiaImmersionOverview,
  },
  {
    path: "europe",
    banner: EuropeImmersionBanner,
    benefit: EuropeImmersionBenefit,
    objectives: EuropeImmersionObjectives,
    overview: EuropeImmersionOverview,
  },
  {
    path: "north-america",
    banner: NorthAmericaImmersionBanner,
    benefit: NorthAmericaImmersionBenefit,
    objectives: NorthAmericaImmersionObjectives,
    overview: NorthAmericaImmersionOverview,
  },
];

export default function ImmersionCountryPage() {
  const { pageName } = useParams();
  const [pageData, setPageData] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    const currentPageData = jsonData.find((data) => data?.path === pageName);
    setPageData(currentPageData);
  }, [pageName]);

  return (
    <div>
      <Navbar />
      <BackRouteContainer
        path={"/immersion"}
        logo={logo}
        title={"Immersion Main Page"}
      />

      {/* Display the banner dynamically */}
      <ImmersionBanner data={pageData?.banner} />
      <ImmerisonCountryBenefit data={pageData?.benefit} />
    </div>
  );
}
